import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Badge,
  Paper,
  TextField,
  Button,
  Box,
  Divider,
} from '@material-ui/core';

const drawerWidth = 300;

const styles = (theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  chatContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  messagesArea: {
    flexGrow: 1,
    padding: theme.spacing(2),
    overflowY: 'auto',
  },
  inputArea: {
    display: 'flex',
    padding: theme.spacing(2),
    borderTop: '1px solid #ccc',
  },
  messageBubble: {
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1),
    borderRadius: 10,
    maxWidth: '70%',
  },
  messageOwn: {
    backgroundColor: '#DCF8C6',
    alignSelf: 'flex-end',
  },
  messageOther: {
    backgroundColor: '#FFF',
    alignSelf: 'flex-start',
  },
  statusText: {
    fontSize: '0.8rem',
    color: '#888',
  }
});

class WhatsAppChat extends React.Component {
  state = {
    selectedUser: null,
    messages: [],
    users: [
      { id: 1, name: 'João Silva', status: 'livre' },
      { id: 2, name: 'Maria Souza', status: 'em_atendimento', atendente: 'Carlos' },
    ],
    newMessage: '',
  };

  handleSelectUser = (user) => {
    // Aqui, você carregaria o histórico da conversa com o usuário
    this.setState({
      selectedUser: user,
      messages: [
        { id: 1, sender: 'cliente', text: 'Olá, preciso de ajuda.' },
        { id: 2, sender: 'atendente', text: 'Claro! Em que posso ajudar?' },
      ],
    });
  };

  handleSendMessage = () => {
    const { newMessage, messages } = this.state;
    if (!newMessage.trim()) return;

    const msg = { id: Date.now(), sender: 'atendente', text: newMessage };
    this.setState({
      messages: [...messages, msg],
      newMessage: '',
    });

    // Aqui você chama sua API Z-API para envio da mensagem
  };

  render() {
    const { classes } = this.props;
    const { selectedUser, messages, users, newMessage } = this.state;

    return (
      <div className={classes.root}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{ paper: classes.drawerPaper }}
        >
          <Toolbar />
          <List>
            {users.map((user) => (
              <ListItem
                button
                key={user.id}
                selected={selectedUser && selectedUser.id === user.id}
                onClick={() => this.handleSelectUser(user)}
              >
                <ListItemText
                  primary={user.name}
                  secondary={
                    user.status === 'em_atendimento'
                      ? `Em atendimento por ${user.atendente}`
                      : 'Disponível'
                  }
                />
                {user.status === 'em_atendimento' && (
                  <Badge color="secondary" variant="dot" />
                )}
              </ListItem>
            ))}
          </List>
        </Drawer>

        <div className={classes.chatContainer}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="h6" noWrap>
                {selectedUser ? selectedUser.name : 'Selecione um contato'}
              </Typography>
            </Toolbar>
          </AppBar>

          {selectedUser ? (
            <>
              <Box className={classes.messagesArea}>
                {messages.map((msg) => (
                  <Paper
                    key={msg.id}
                    className={`${classes.messageBubble} ${
                      msg.sender === 'atendente'
                        ? classes.messageOwn
                        : classes.messageOther
                    }`}
                  >
                    <Typography>{msg.text}</Typography>
                  </Paper>
                ))}
              </Box>

              <div className={classes.inputArea}>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Digite uma mensagem"
                  value={newMessage}
                  onChange={(e) => this.setState({ newMessage: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') this.handleSendMessage();
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleSendMessage}
                  style={{ marginLeft: 10 }}
                >
                  Enviar
                </Button>
              </div>
            </>
          ) : (
            <Box p={3}>
              <Typography variant="body1">Selecione um usuário para começar.</Typography>
            </Box>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(WhatsAppChat);
